module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "exp"
  }, _vm._l((_vm.list), function(item) {
    return _c('div', {
      staticClass: "item"
    }, [_c('img', {
      attrs: {
        "src": item.medal,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', [_vm._v("所需经验" + _vm._s(item.exp))])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-07a8f060","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/ExpDesc.vue
// module id = 407
// module chunks = 7